module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-02.6a3425bb.jpeg";